import React, {useEffect, useState} from 'react'
import {Button, FormControl, InputLabel, TextField} from '@mui/material'
import {styled} from '@mui/material/styles'
import {useDispatch} from 'react-redux'
import * as form from '../modules/insurance/healthInsurance/redux/healthInsuranceRedux'
import * as auto from '../modules/insurance/AutoInsurance/redux/autoRedux'
import * as moto from '../modules/insurance/MotoInsurance/redux/motoRedux'
import * as user from '../modules/insurance/healthInsurance/redux/userRedux'
import * as filter from '../redux-commons/FilterRedux/filterRedux'
import * as product from '../modules/insurance/InsuranceProducts/redux/productRedux'
import {CustomInputLable} from './SelectField'
import {validateSpecialChar} from '../utils'
import {reformatText} from '../utils/InputFormatCurrency'
import {InputField} from './InputField'
import {CustomModal} from '../../_metronic/partials/modals/CustomModal'
import {SearchInput} from './SearchInput'
import {TableComponent} from '../../_metronic/partials/widgets'

type Props = {
  label: string
  id: string
  inputClass?: string
  name: string
  placehoder: string
  wrapperClass?: string
  inputValue?: string
  tabName?: string
  modalTitle: string
  column: any
  dataRows: any
  totalRows: any
  formName?: string
  validateField?: boolean
  required?: boolean
  handleInputChange?: (value: string) => void
  handlePageChange: (page: number) => void
  handleValuePicked: (value: string) => void
}

export const InputModalPicker: React.FC<Props> = ({
  label,
  id,
  inputClass,
  name,
  wrapperClass,
  inputValue,
  tabName,
  formName,
  required,
  validateField,
  handleInputChange,
  placehoder,
  modalTitle,
  column,
  dataRows,
  totalRows,
  handlePageChange,
  handleValuePicked,
}) => {
  const [openModal, setOpenModal] = useState(false)
  const [value, setValue] = useState('')
  const [loading, setLoading] = useState(true)
  const dispatch = useDispatch()

  const handleSaveData = (event: any) => {
    let value = event.target.value
    setValue(value.trim())
    if (formName && formName.toLowerCase().includes('formperson')) {
      let data = {
        key: id,
        value: value.trim(),
        tab: tabName ? tabName : '',
        form: formName ? formName : '',
      }
      dispatch(form.actions.addProductInfo(data))
    } else if (formName && formName.toLowerCase().includes('auto')) {
      let data = {
        key: id,
        value: value.trim(),
        tab: tabName ? tabName : '',
        form: formName ? formName : '',
      }
      dispatch(auto.actions.addAutoInfos(data))
    } else if (formName && formName.toLowerCase().includes('moto')) {
      let data = {
        key: id,
        value: value.trim(),
        tab: tabName ? tabName : '',
        form: formName ? formName : '',
      }
      dispatch(moto.actions.addMotoInfos(data))
    } else if (formName && formName.toLowerCase().includes('product')) {
      let data = {
        key: id,
        value: value.trim(),
        tab: tabName ? tabName : '',
        form: formName ? formName : '',
      }
      dispatch(product.actions.addProductInfos(data))
    } else if (formName && formName.toLocaleLowerCase().includes('filter')) {
      let data = {
        field: id ? id : '',
        value: value,
        filterForm: formName,
      }
      dispatch(filter.actions.updateFilterInfo(data))
    } else if (formName === 'user') {
      let data = {
        key: id,
        value: value.trim(),
      }
      dispatch(user.actions.addUserInfo(data))
    }
  }

  const handleChangeData = (value: string) => {
    setLoading(true)
    if (handleInputChange) handleInputChange(value)
  }

  const handleOpenModal = () => {
    setOpenModal(true)
  }

  const handleOnChangePage = (page: number) => {
    setLoading(true)
    handlePageChange(page)
  }

  const handleTableRowClicked = (param: any) => {
    if (param?.code) handleValuePicked(param.code)
    setValue(param.name)
    setOpenModal(false)
  }

  useEffect(() => {
    if (inputValue) {
      if (dataRows?.length > 0)
        setValue(() => dataRows.find((o: any) => o.code == inputValue)?.name || '')
      else setValue(() => inputValue)
    } else setValue('')
  }, [inputValue])

  useEffect(() => {
    setLoading(false)
  }, [dataRows])

  return (
    <>
      <div className={wrapperClass ? wrapperClass : 'field-wrapper'}>
        <InputField
          label={label}
          placehoder={placehoder}
          required={required}
          id={id}
          name={id}
          inputReadonly
          inputValue={value}
          validateField={validateField}
        />
        <Button
          size='small'
          variant='contained'
          sx={{position: 'absolute', top: '4px', right: '4px'}}
          onClick={() => handleOpenModal()}
        >
          Chọn
        </Button>
      </div>
      <CustomModal
        open={openModal}
        handleCloseModal={(closed) => setOpenModal(closed)}
        widthModal='60%'
        modalTitle={modalTitle}
        ModalBtn={() => <></>}
      >
        <div className='tabel-feature-wrapper'>
          <SearchInput handleSearchValue={handleChangeData} />
          {/* <div className='tabel-feature-btn'>
              <Button size='small' variant='text'>
                Tìm nâng cao
              </Button>
            </div> */}
        </div>
        <TableComponent
          pageSize={10}
          rowData={dataRows}
          column={column}
          heightTable='400px'
          handleDoubleClickRow={handleTableRowClicked}
          handleClickRow={() => {}}
          handleOnChangePage={handleOnChangePage}
          loading={loading}
          totalRows={totalRows}
        />
      </CustomModal>
    </>
  )
}
